export const en = {
  nonprofitApp: {
    nav: {
      myEvents: 'My Events',
      donations: 'Donations',
      nonprofitSettings: 'Organization Settings',
      employees: 'Employees',
    },
    donations: {
      title: 'Donations',
      searchPlaceholder: 'Search donations...',
      columns: {
        donor: 'Donor',
        amount: 'Amount',
        receipt: 'Receipt #',
        status: 'Status',
        date: 'Date',
      },
      empty: {
        title: 'No Donations',
        subtitle: "You haven't received any donations yet.",
      },
    },
    dashboard: {
      description: 'This is your organization dashboard where you can manage your events and see your impact.',
      checklist: {
        title: 'Complete your organization profile',
        subtitle: 'Help donors and volunteers learn about your organization.',
        logo: 'Upload a logo',
        shortDescription: 'Add a short description',
        longDescription: 'Add a long description',
        stripe: 'Connect Stripe to accept donations',
      },
      stats: {
        activeEvents: 'Active Events',
        uniqueVolunteers: 'Unique Volunteers',
        totalSignUps: 'Total Sign Ups',
        hoursVolunteered: 'Hours Volunteered',
      },
    },
    events: {
      title: 'My Events',
      searchPlaceholder: 'Search events...',
      columns: {
        eventName: 'Event Name',
        company: 'Company',
        date: 'Date',
        location: 'Location',
        attendance: 'Attendance',
        status: 'Status',
      },
      statuses: {
        cancelled: 'Cancelled',
        published: 'Published',
        draft: 'Draft',
      },
      virtual: 'Virtual',
      empty: {
        title: 'No Events',
        subtitle: "You don't have any events yet.",
      },
    },
    settings: {
      title: 'Organization Settings',
      alerts: {
        stripeConnected: 'Stripe account connected!',
        stripeError: 'Could not verify Stripe account. Please try again.',
        stripeOnboardingError: 'Failed to start Stripe onboarding. Please try again.',
        saved: 'Settings updated successfully',
      },
      sections: {
        generalInformation: 'General Information',
        longDescription: 'Long Description',
        location: 'Location',
        logo: 'Logo',
        badge: 'Badge',
        donations: 'Donations',
      },
      fields: {
        website: { label: 'Website', placeholder: 'https://your-organization.org' },
        shortSummary: {
          label: 'Short Summary',
          placeholder: 'Tell us about your organization...',
          hint: "1-2 sentences summarizing your organization's goal or mission.",
        },
        addressSearch: {
          label: 'Address Search',
          placeholder: 'Search for your address...',
          hint: 'Selecting an address will auto-fill the fields below.',
        },
        addressLine: { label: 'Address Line', placeholder: '123 Main St' },
        city: { label: 'City', placeholder: 'City' },
        provinceState: { label: 'Province / State', placeholder: 'Province / State' },
        postalZip: { label: 'Postal / Zip Code', placeholder: 'Postal / Zip Code' },
        country: { label: 'Country', hint: 'Country cannot be changed after approval.' },
        logo: { hint: 'Upload a logo for {{name}}' },
        badge: { hint: 'Upload a badge for {{name}}' },
      },
      stripe: {
        connected: '✓ Connected & accepting donations',
        connectedHint: 'Your Stripe account is fully set up. Donors will see a "Donate" button on your profile.',
        incomplete: '⚠ Onboarding incomplete',
        incompleteHint: "You started Stripe onboarding but haven't finished. Click below to continue where you left off.",
        notConnected: 'Not connected',
        notConnectedHint: 'Connect a Stripe account to enable donations on your profile. Funds are deposited directly to you — Purposely takes a small platform fee.',
        continueOnboarding: 'Continue Stripe onboarding',
        connect: 'Connect to Stripe',
        loading: 'Loading…',
      },
    },
    employees: {
      title: 'Manage Employees',
      searchPlaceholder: 'Search employees...',
      unsavedChanges: '{{count}} unsaved change(s)',
      discard: 'Discard',
      save: 'Save',
      saving: 'Saving...',
      columns: {
        name: 'Name',
        email: 'Email',
        isActive: 'Is Active',
        isAdmin: 'Is Admin',
        joinedAt: 'Joined At',
      },
      empty: {
        title: 'No Employees',
        subtitle: "This organization doesn't have any employees yet.",
      },
    },
    accountSettings: {
      nav: {
        profile: 'Profile',
        password: 'Password',
        notifications: 'Notifications',
      },
      profile: {
        title: 'Profile',
        subtitle: 'Update your profile information.',
        sectionTitle: 'Profile photo',
        sectionDescription: 'This photo is visible to others on the platform.',
        firstName: 'First name',
        lastName: 'Last name',
        saveButton: 'Save changes',
        saved: 'Profile updated.',
      },
      notifications: {
        title: 'Notifications',
        comingSoon: 'Notification preferences coming soon.',
      },
    },
  },
}
